<template>
  <div style="padding: 0 10px">
    <div class="headerBox">
      <div style="display: flex; justify-content: flex-start">
        <div class="searchbox">
          <div class="infoBox">
            <ScanQuery ph="输入批次包" @onQuery="queryCall" ref="ScanQuery" />
            <el-tag type="warning" effect="dark" v-if="packageInfo.allIncludeFlag === 1">一价全包</el-tag>
            <div style="flex:1">
            </div>
            <div class="limitBox" v-if="packageInfo.pkgCode">客户店铺名称：{{ packageInfo.customerShopName }}</div>
            <div style="display: flex; margin-left: 20px">
              <IptNumber placeholder="重量" :value="packageInfo.weight" unit="克" @enter="weightSet" ref='weightIpt' />
            </div>
          </div>
          <div class="splitBox">
            <div style="width: 440px;">
              <el-select style="margin-right:10px;width:140px" v-model="boxCode" @change="selectBoxTemplate">
                <el-option v-for="item in boxTemplates" :key="item.boxTemplateId" :label="item.templateName"
                  :value="item.boxTemplateId">
                </el-option>
              </el-select>
              <el-input style="width: 80px" placeholder="长" v-model="boxSizeInfo.length"></el-input> *
              <el-input style="width: 80px" placeholder="宽" v-model="boxSizeInfo.width"></el-input> *
              <el-input style="width: 80px" placeholder="高" v-model="boxSizeInfo.height"></el-input>
            </div>
            <div style="flex:1">
              <template v-if="packageInfo.customerTagNameList?.length">
                <div class="publicCustomerTagName" v-for="item in packageInfo.customerTagNameList" :key="item">{{ item
                  }}</div>
              </template>
            </div>
          </div>
        </div>
        <div style="display:flex ; margin-left: 10px; flex-wrap: wrap;align-content: space-between;width:230px">
          <el-button type="success" style="margin-top: 11px" @click="batchPack">
            打包完成
          </el-button>
        </div>
      </div>
      <div class="product-content" v-if="packageInfo.pkgCode">
        <div class="product-img">
          <img :src="packageInfo.productImg" alt="">
        </div>
        <div class="product-info">
          <div>
            商品SKU：{{ packageInfo.shopProductSku }}
          </div>
          <div>
            商品名称：{{ packageInfo.productName }}
          </div>
          <div>
            批次包：{{ packageInfo.pkgCode }}
          </div>
          <div>
            发货数量：<span>{{ packageInfo.deliveryNums }}</span>
          </div>
        </div>
      </div>
    </div>
    <el-tabs v-model="groupIndex">
      <el-tab-pane :label="`分组${index + 1}（${item.deliveryTaskGroupDataVOList.length}）`" :name="String(index)"
        v-for="(item, index) in (packageInfo.explosiveProductPackGroup || [])" :key="index"></el-tab-pane>
    </el-tabs>
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>单证备注信息</span>
        <span class="receiverNation" v-if="packageInfo.pkgCode">收货国家:{{ packageItem.receivingNationName }}</span>
        <!-- <span style="color:red;margin-left:100px;" v-if="packageInfo.pkgCode">打包失败：2</span> -->
      </div>
      <div style="text-align: left">
        备注内容：<span style="color:red;font-size: 26px">{{ packageItem.auditRemark || '-' }}</span>
      </div>
      <div style="display:flex;align-items:center;gap:12px;flex-wrap:wrap;margin-top:10px;text-align:left">
        <span>货代公司：{{ packageItem.wmsForwarder || '-' }}-{{ packageItem.wmsShippingType || '-' }}</span>
        <el-button v-if="packageInfo.pkgCode && Number(packageItem.miniFlag) === 1" type="warning"
          :loading="switchBackupLoading" @click="switchBackupLogisticsChannel">
          切换物流备选渠道
        </el-button>
      </div>
    </el-card>
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>申报信息</span>
      </div>
      <WmsTable :columns="columns" :hasHeader="false" :is-pagination="false"
        :dataSource="packageItem.deliveryTaskAdditionalDetailList">
        <div slot="image" slot-scope="{text}">
          <img :src="text" alt="" style="width:60px;">
        </div>
      </WmsTable>
    </el-card>
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>国际发货单</span>
      </div>
      <WmsTable :columns="columnsTwo" :hasHeader="false" :is-pagination="false"
        :dataSource="packageItem.deliveryTaskGroupDataVOList">
        <div slot="action" slot-scope="{ record }">
          <el-button type="text" @click="packageSingle(record)">打包完成</el-button>
          <div style="margin-top:10px;">
            <el-button type="text" @click="clickPrintPdf(record)">打印物流面单</el-button>
          </div>
        </div>
        <template #logisticsCode="{ record }">
          <div v-if="!record.isEdit" class="logistcs-code">
            <el-tooltip class="item" effect="light" :content="record.logisticsCode" placement="top">
              <span class="code">{{ record.logisticsCode }}</span>
            </el-tooltip>
            <div class="icon">
              <i class="el-icon-edit-outline " @click="editLog(record)"></i>
            </div>
          </div>
          <div v-else style="display: flex; align-items: center;">
            <el-input v-model="record.logisticsCode" :maxLength="50"></el-input><el-button size="small"
              style="margin-left:10px;" @click="saveExpress(record)">保存</el-button>
          </div>
          <div style="margin-top:10px;">
            <el-button type="text" @click="createWaybillNumber(record)">生成物流单号</el-button>
          </div>
        </template>
        <template #message="{ record }">
          <div v-if="record.message" style="color:red;">
            {{ record.message }}
          </div>
          <div v-else>-</div>
        </template>
      </WmsTable>
    </el-card>
  </div>
</template>

<script>
import ScanQuery from "@/components/ScanQuery";
import IptNumber from "@/components/IptNumber";
import WmsTable from "@/components/WmsTable";
import { audioPay } from "@/utils/tools";
import {
  getHotPackingListApi,
  batchUpdateHotWeightApi,
  finishBuildBag,
  batchPackFinishApi,
  getBox,
  setLogisticstInfo,
  getLogisticsNo,
  // 切换物流备选渠道接口。
  switchBackupLogisticsChannel
} from "@/apis/outStock";
import { smallContainer } from '../mixins/smallContainer'
import { margePDF, uploadFile } from '@/utils/autoPrint'
export default {
  name: "SmallSingleBuilding", // 小件单品打包
  mixins: [smallContainer],
  components: {
    ScanQuery,
    IptNumber,
    WmsTable

  },
  data() {
    return {
      query: {
        code: '',
        // current: 1,
        // pageSize: 10,
        // total: 0
      },
      deliveryTaskCode: '', // 发货任务编号
      wmsForwarder: '',
      companyCode: '',
      columns: [
        { title: '附加项名称', key: 'additionName', dataIndex: 'additionName' },
        { title: '辅料名称', key: 'ingredientsName', dataIndex: 'ingredientsName' },
        {
          title: '辅料图片', key: 'image', dataIndex: 'image',
          scopedSlots: {
            customRender: "image",
          },
        },
        { title: '辅料SKU', key: 'ingredientsSku', dataIndex: 'ingredientsSku' },
      ],
      columnsTwo: [
        {
          title: '发货编号',
          key: 'deliveryTaskCode',
          dataIndex: 'deliveryTaskCode',
        },
        {
          title: '订单编号',
          key: 'platformOrderNo',
          dataIndex: 'platformOrderNo',
        },
        { title: '收货国家', key: 'receivingNationName', dataIndex: 'receivingNationName', width: 100 },
        // { title: '客户名称', key: 'customerName', dataIndex: 'customerName' },
        // { title: '批次号', key: 'pkgCode', dataIndex: 'pkgCode' },
        { title: '发货数量', key: 'deliveryNums', dataIndex: 'deliveryNums', width: 100 },
        {
          title: '物流单号', key: 'logisticsCode', dataIndex: 'logisticsCode', scopedSlots: {
            customRender: "logisticsCode",
          },
        },
        {
          title: '失败原因', key: 'message', dataIndex: 'message', fixed: 'right', width: 250, scopedSlots: {
            customRender: "message",
          },
        },
        {
          title: '操作', key: 'action', dataIndex: 'action', fixed: 'right', width: 120, scopedSlots: {
            customRender: "action",
          },
        },
      ],
      customerShopName: '',
      additionalDataSource: [],
      productDataSource: [],
      links: [],
      interceptStatus: false,
      receiverNation: '',
      auditRemark: '',
      dialogVisible: false,
      dialogContainerCode: '',
      containerCode: '',
      boxTemplates: [],
      boxCode: '',
      boxSizeInfo: {},
      customerTagNameList: [],
      // 切换客户备选渠道加载状态。
      switchBackupLoading: false,
      packageInfo: {

      },
      groupIndex: '0'
    }
  },
  computed: {
    //sku种类数量
    skuNum() {
      var skuList = [];
      this.productDataSource.forEach((item) => {
        if (skuList.indexOf(item.productSku) == -1) {
          skuList.push(item.productSku);
        }
      });
      return skuList.length;
    },
    //总商品数
    totalNum() {
      var num = 0;
      this.productDataSource.forEach((item) => {
        num += item.deliveryNums;
      });
      return num;
    },
    focusTarget() {
      if (this.dialogVisible) {
        return this.$refs.containerIpt
      }
      if (this.productDataSource.length) {
        return this.$refs.weightIpt
      }
      return this.$refs.ScanQuery
    },
    packageItem() {
      return this.packageInfo.explosiveProductPackGroup?.[this.groupIndex] || {}
    }
  },
  mounted() {
    getBox().then(({ code, data }) => {
      if (code == 0) {
        this.boxTemplates = data;
      }
    });
  },
  methods: {
    clickPrintPdf(record) {
      if (!record.logisticsTagUrl) {
        this.$message.warning('请线下打印面单')
        return
      }
      this.$printSheet(record.wmsIntForwarderConfigId, [record.logisticsTagUrl]).catch(async () => {
        window.open(record.logisticsTagUrl)
      });
    },
    // 称重
    weightSet: function (val) {
      const _this = this;
      if (_this.packageInfo.weight == val) {
        return
      }
      if (isNaN(val)) {
        this.$message.warning('请输入数字')
        return
      }
      function nextStep() {
        const codeList = []
        _this.packageInfo.explosiveProductPackGroup.forEach((item) => {
          item.deliveryTaskGroupDataVOList.forEach((temp) => {
            codeList.push(temp.deliveryTaskCode)
          })
        })
        const params = {
          deliveryTaskCodeList: codeList,
          weight: val
        };
        batchUpdateHotWeightApi(params).then(({ code, data }) => {
          if (code === 0) {
            _this.packageInfo.weight = val;
            if (data.needNotice) {
              _this.$message.success(data.message);
            } else {
              _this.$message.success(`重量: ${val} g`);
            }
          }
        });
      }
      if (val || val === 0) {
        console.log(val, val > 200)
        if (val > 200) {
          nextStep()
          return
        }
        setTimeout(() => {
          _this.$confirm(`重量${val}克，是否提交`, "提示", {
            confirmButtonText: "确认",
            type: "warning",
            cancelButtonText: "取消",
            closeOnPressEscape: false,
            closeOnClickModal: false
          }).then(() => {
            nextStep()
          }).catch(() => {
          });
        }, 100);

      }
    },
    queryCall: function (payload) {
      this.query.code = payload.code
      this.getSingleCheck()
      this.boxCode = ''
      this.boxSizeInfo.length = ''
      this.boxSizeInfo.width = ''
      this.boxSizeInfo.height = ''
    },
    getSingleCheck(isUpdate) {
      const _this = this
      const params = {
        pkgCode: _this.query.code
      }

      getHotPackingListApi(params).then(res => {
        if (!res.success) {
          this.packageInfo = {}
          _this.groupIndex = '0'
          return
        }
        console.log(res.data, 'packageInfo');

        this.packageInfo = res.data
        if (isUpdate) {
          _this.groupIndex = res.data.explosiveProductPackGroup.length <= _this.groupIndex ? '0' : _this.groupIndex
        } else {
          _this.groupIndex = '0'
        }
      }).catch(() => {
        alert('error')
      })
    },
    // 选中箱子模板
    selectBoxTemplate: function (val) {
      const _this = this
      // 当选中固定模板时
      if (!!val && val !== '') {
        _this.boxTemplates.forEach(item => {
          if (item.boxTemplateId === val) {
            const { width, length, height } = item
            _this.boxSizeInfo = {
              width,
              length,
              height
            }
          }
        })
      }
    },
    packageSingle(item) {
      const _this = this;
      if (!_this.packageInfo.weight && _this.packageInfo.weight !== 0) {
        _this.$message.error("请填写包裹重量！");
        return;
      }
      finishBuildBag({
        deliveryTaskCode: item.deliveryTaskCode,
        platformOrderNo: item.platformOrderNo,
        width: _this.boxSizeInfo.width,
        length: _this.boxSizeInfo.length,
        height: _this.boxSizeInfo.height,
        weight: _this.packageInfo.weight
      }).then(() => {
        _this.$message.success("打包完成");
        setTimeout(() => {
          if (!item.logisticsTagUrl) {
            _this.$message.warning('请线下打印面单')
            return
          }
          if (item.wmsIntForwarderConfigId && item.logisticsTagUrl) {
            // 自动打印
            _this.$printSheet(item.wmsIntForwarderConfigId, [item.logisticsTagUrl]).catch(() => {
              window.open(
                item.logisticsTagUrl
              );
            });
          } else {
            window.open(item.logisticsTagUrl)
          }
        }, 500)
        _this.getSingleCheck(true)
      })
    },
    batchPack() {
      const _this = this;

      if (!_this.packageInfo.pkgCode) return
      if (!_this.packageInfo.weight && _this.packageInfo.weight !== 0) {
        _this.$message.error("请填写包裹重量！");
        return;
      }
      const num = _this.packageItem.deliveryTaskGroupDataVOList.reduce((total, v) => {
        return total + v.deliveryNums
      }, 0)
      _this.$confirm(`仅打印当前分组，共${num}件`, "打包完成确认", {
      }).then(() => {
        batchPackFinishApi({
          deliveryTaskCodeList: _this.packageItem?.deliveryTaskGroupDataVOList?.map(v => v.deliveryTaskCode),
          width: _this.boxSizeInfo.width,
          length: _this.boxSizeInfo.length,
          height: _this.boxSizeInfo.height,
          weight: _this.packageInfo.weight
        }).then(async (res) => {
          audioPay('打包完成')
          console.log(res)
          const { logisticsTagUrlList, successNum, failNum, intForwarderConfigId } = res.data
          _this.$confirm(`成功数量：${successNum}，失败数量：${failNum}。`, "提示", {
          }).finally(() => {
            _this.getSingleCheck(true)
          })
          if (failNum > 0) {
            setTimeout(() => {
              audioPay(`失败${failNum}件`)
            }, 500)
          }
          if (logisticsTagUrlList?.length) {
            //先合并pdf
            console.log(res)
            _this.$printSheet(intForwarderConfigId, logisticsTagUrlList).catch(async () => {
              const newFile = await margePDF(logisticsTagUrlList)
              const newUrl = await uploadFile(newFile)
              window.open(newUrl)
            });
          }
        })
      })

    },
    // 切换客户备选渠道并刷新页面数据。
    switchBackupLogisticsChannel: async function () {
      // 当前分组的发货任务编号集合。
      const deliveryTaskCodeList = this.packageItem?.deliveryTaskGroupDataVOList?.map((item) => item.deliveryTaskCode) || [];
      if (!deliveryTaskCodeList.length) {
        this.$message.warning("缺少发货任务编号");
        return;
      }

      try {
        await this.$confirm("确认切换物流备选渠道？", "提示", {
          confirmButtonText: "确认",
          cancelButtonText: "取消",
          type: "warning",
        });
      } catch (e) {
        return;
      }

      this.switchBackupLoading = true;
      try {
        // 切换客户备选渠道接口响应。
        const res = await switchBackupLogisticsChannel(deliveryTaskCodeList);
        if (res.code !== 0) return;

        this.$message.success("切换成功");
        this.getSingleCheck(true);
      } finally {
        this.switchBackupLoading = false;
      }
    },
    editLog(record) {
      this.$set(record, 'isEdit', true)
    },
    saveExpress(record) {
      if (!record.logisticsCode) {
        this.$message.warning('请填写物流')
        return
      }
      const params = {
        deliveryTaskLogisticsDetailId: record.deliveryTaskLogisticsDetailId,
        deliveryTaskCode: record.deliveryTaskCode,
        logisticsCode: record.logisticsCode,
      };
      setLogisticstInfo(params).then((res) => {
        console.log(res)
        if (!res.success) return
        this.$message.success("物流号更新成功！");
        record.isEdit = false
        record.logisticsTagUrl = ''
      });
    },
    createWaybillNumber(record) {
      let params = {
        deliveryTaskCode: record.deliveryTaskCode,
      };
      getLogisticsNo(params).then(({ code }) => {
        if (code == 0) {
          this.$message.success("操作成功");
          this.getSingleCheck()
        }
      });
    },
  }
}
</script>

<style scoped lang="less">
.logistcs-code {
  display: flex;
  align-items: center;

  .code {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .icon {
    margin-left: 10px;
    flex: 1;
  }
}

.el-icon-edit-outline {
  color: #409EFF;
  cursor: pointer;
  font-size: 16px;
}

.product-content {
  display: flex;
  padding: 20px 0;

  .product-img {
    width: 120px;
    margin-right: 20px;

    img {
      width: 120px;
    }
  }

  .product-info {
    flex: 1;

    div {

      text-align: left;

      span {
        color: red;
        font-size: 18px;
        font-weight: 800;
      }
    }
  }
}

.box-card ::v-deep.el-card__header {
  background: #f8f8f8;
}

.box-card {
  margin-bottom: 20px;
}

.clearfix {
  text-align: left;
  font-size: 14px;
  font-weight: bold;
}

.limitBox {
  border: 1px #eee solid;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  padding: 4px 10px;
  color: red;
}

#pdf {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  z-index: -1;
}

.receiverNation {
  font-size: 14px;
  font-weight: 600;
  margin-left: 10px;
  color: red;
  margin-left: 100px;
}

.headerBox {
  background-color: #ddeeff;
  box-sizing: border-box;
  padding: 10px;
  margin-bottom: 10px;
  border-radius: 4px;
}

.headerBox .headerBtn {
  height: 80px;
}

.searchbox {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  flex: 1;
}

.infoBox {
  display: flex;
  align-items: center;
  width: 100%;
}

.splitBox {
  display: flex;
  flex-shrink: 0;
  text-align: left;
  width: 100%;
}
</style>
